import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockIcon from '@material-ui/icons/Lock';
import { DatePicker } from '@material-ui/pickers';
import FormContext from '../FormContext';

const useStyles = makeStyles(theme => ({
  inputRoot: {
    background: theme.palette.grey[50],
    '&.Mui-disabled': {
      background: theme.palette.grey[50]
    }
  }
}));

function getMinDate(minDate) {
  return minDate || new Date(1970, 1, 1);
}

function getMaxDate(maxDate) {
  return maxDate || new Date(2100, 1, 1);
}

const DateField = ({
  label,
  dataField,
  helperText,
  minDate,
  maxDate,
  disabled = false,
  dateFormat
}) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const { getFieldValue, setFieldValue } = useContext(FormContext);
  const id = `form-field/${dataField}`;
  const value =
    getFieldValue(dataField) === '' ? null : getFieldValue(dataField);

  function getInputProps() {
    const inputProps = {
      classes: {
        root: classes.inputRoot
      }
    };
    if (disabled) {
      inputProps.endAdornment = (
        <InputAdornment position="end">
          <LockIcon />
        </InputAdornment>
      );
    }
    return inputProps;
  }

  function getLabel() {
    return label ? formatMessage({ id: label }) : label;
  }

  function getHelperText() {
    return helperText ? formatMessage({ id: helperText }) : helperText;
  }

  function onChange(newValue) {
    setFieldValue(dataField, newValue);
  }

  return (
    <DatePicker
      label={getLabel()}
      helperText={getHelperText()}
      value={value}
      format={dateFormat || 'yyyy-MM-dd'}
      minDate={getMinDate(minDate)}
      maxDate={getMaxDate(maxDate)}
      InputProps={getInputProps()}
      disabled={disabled}
      onChange={onChange}
      emptyLabel=""
      id={id}
      fullWidth
      autoOk
      inputVariant="filled"
      clearable
      margin="normal"
    />
  );
};

DateField.propTypes = {
  label: PropTypes.string.isRequired,
  dataField: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  disabled: PropTypes.bool
};

export default DateField;
